// @ts-strict-ignore
import { LazyMotion } from "framer-motion";
import React from "react";
const loadFeatures = () =>
  import("./framerMotionFeatures.js").then((res) => res.default);
export function FramerLazyMotion({ children }) {
  return (
    <LazyMotion features={loadFeatures} strict>
      {children}
    </LazyMotion>
  );
}
